import { useField, type FieldComponentProps } from "@w3rone/json-schema-form"
import { WysiwygEditor } from "../../WysiwygEditor"
import Box from "@mui/material/Box"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import Tooltip from "@mui/material/Tooltip"
import Info from "@mui/icons-material/Info"
import { FormErrors } from "./FormErrors"
import { useMemo } from "react"

export function WysiwygField({ name }: FieldComponentProps) {
  const { value, schema, label, description, errors, onChange } = useField(name)

  if (value !== undefined && typeof value !== "string") {
    throw new Error(`Bad WyiswygField value: ${value}`)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const options = schema.options as any

  const enabledWidgets = useMemo(
    () => new Set<string>(options.wysiwyg.options),
    [options.wysiwyg.options],
  )

  return (
    <FormControl variant={"standard"} error={errors.length > 0} fullWidth>
      {label ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FormLabel component="legend">{label}</FormLabel>

          {description ? (
            <Tooltip
              title={<div dangerouslySetInnerHTML={{ __html: description }} />}
            >
              <Info />
            </Tooltip>
          ) : null}
        </Box>
      ) : null}

      <FormErrors errors={errors} />

      <WysiwygEditor
        placeholder={schema.options.attr?.placeholder}
        // @ts-expect-error I don't know how to tell TS that the editor has the markdown plugin enabled
        onChange={({ editor }) => onChange?.(editor.api.markdown.serialize())}
        initialValue={value ?? ""}
        enabledWidgets={enabledWidgets}
      />

      <textarea hidden value={value} name={name} readOnly={true} />
    </FormControl>
  )
}
